module.exports = __webpack_public_path__ + "assets/021d6034afb15a392215a3a7ac058c9a.json";